import React from 'react';

const TeamMemberCard = ({ name, title, description, photoUrl = null }) => {
  return (
    <div className="bg-lightgray p-6 rounded-lg flex flex-col items-center">
      <div className="w-32 h-32 bg-gray-300 rounded-full mb-4 flex items-center justify-center text-gray-500 overflow-hidden">
        {photoUrl ? (
          <img 
            src={photoUrl} 
            alt={name} 
            className="w-full h-full object-cover" 
          />
        ) : (
          <span>Photo</span>
        )}
      </div>
      <h3 className="font-semibold text-primary mb-2">{name}</h3>
      <p className="text-gray-700 text-sm">{title}</p>
      <p className="text-gray-600 text-sm mt-2 text-center">{description}</p>
    </div>
  );
};

export default TeamMemberCard;